import { render, staticRenderFns } from "./DefectShow.vue?vue&type=template&id=1c5dc73a&"
import script from "./DefectShow.vue?vue&type=script&lang=js&"
export * from "./DefectShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports